export default __webpack_public_path__ + "static/media/happyFace.61e4d9e9.svg";